import { EMPHASIS_TWEEN_DOCUMENT_KEY, ENTRANCE_TWEEN_DOCUMENT_KEY, EXIT_TWEEN_DOCUMENT_KEY } from 'js/config/consts';

export type StageTweenKey = 'entranceTween' | 'emphasisTween' | 'exitTween';

export function getStageTweenKey(stage: string): StageTweenKey {
  if (stage === 'entrance') return ENTRANCE_TWEEN_DOCUMENT_KEY;
  if (stage === 'emphasis') return EMPHASIS_TWEEN_DOCUMENT_KEY;
  if (stage === 'exit') return EXIT_TWEEN_DOCUMENT_KEY;
  return EXIT_TWEEN_DOCUMENT_KEY;
}
